<template>
  
  <vanConfigProvider :theme="getDarkMode" :theme-vars="getThemeVars()">
    <van-nav-bar
      class="header header-view-nav app-limit-width"
      :title="$route.meta.title || ''"
      left-arrow
      placeholder
      :border="false"
      v-if="showNavBack"
      @click-left="onClickLeft"
    />
    <router-view v-slot="{ Component }">
      <div class="root-class">
        <keep-alive v-if="keepAliveComponents" :include="keepAliveComponents">
          <component :is="Component" />
        </keep-alive>
      </div>
    </router-view>
  </vanConfigProvider>
</template>

<script setup>
  import { computed, unref } from 'vue'
  import { darken, lighten } from '@/utils/colorUtils'
  import { useRouteStore } from '@/stores/modules/route'
  import { useDesignSetting } from '@/hooks/setting/useDesignSetting'
  import { isHeaderNavBar } from '@/utils/isUtils'
  import { useRouter, useRoute } from 'vue-router';
  const router = useRouter();
  const route = useRoute()
  const routeStore = useRouteStore()
  const { getDarkMode, getAppTheme } = useDesignSetting()
  const { VITE_APP_PREVIEW_SAAS_URL } = import.meta.env

  // 需要缓存的路由组件
  const keepAliveComponents = computed(() => routeStore.keepAliveComponents)
  const showNavBack = computed(() => isHeaderNavBar() && router.currentRoute.value.meta.showHeaderNavBar)
  console.log("showNavBack",showNavBack.value)
  const onClickLeft = () => {
    if(route.query.comeType=='pay' && route.name=='OrderList'){
      location.replace(VITE_APP_PREVIEW_SAAS_URL)
    }else{
      router.back()
    }
    
  }
  const getThemeVars = () => {
    const appTheme = unref(getAppTheme)
    const darkenStr = darken(appTheme, 25)
    const lightenStr = lighten(appTheme, 10)

    return {
      actionSheetCancelTextColor: appTheme,
      buttonPrimaryBackground: appTheme,
      buttonPrimaryBorderColor: appTheme,
      radioCheckedIconColor: appTheme,
      sliderActiveBackground: appTheme,
      cascaderActiveColor: appTheme,
      checkboxCheckedIconColor: appTheme,
      numberKeyboardButtonBackground: appTheme,
      pickerLoadingIconColor: appTheme,
      calendarRangeEdgeBackground: appTheme,
      calendarRangeMiddleColor: appTheme,
      calendarSelectedDayBackground: appTheme,
      stepperButtonRoundThemeColor: appTheme,
      switchOnBackground: appTheme,
      dialogConfirmButtonTextColor: appTheme,
      dropdownMenuOptionActiveColor: appTheme,
      dropdownMenuTitleActiveTextColor: appTheme,
      notifyPrimaryBackground: appTheme,
      circleColor: appTheme,
      noticeBarBackground: lightenStr,
      noticeBarTextColor: darkenStr,
      progressColor: appTheme,
      progressPivotBackground: appTheme,
      stepActiveColor: appTheme,
      stepFinishLineColor: appTheme,
      swipeIndicatorActiveBackground: appTheme,
      tagPrimaryColor: appTheme,
      navBarIconColor: appTheme,
      navBarTextColor: appTheme,
      paginationItemDefaultColor: appTheme,
      sidebarSelectedBorderColor: appTheme,
      tabsDefaultColor: appTheme,
      tabsBottomBarColor: appTheme,
      tabbarItemActiveColor: appTheme,
      treeSelectItemActiveColor: appTheme
      // dividerTextColor: appTheme,
    }
  }
</script>

<style lang="less">
  @import './assets/styles/index.less';
  .root-class {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow: hidden;
  }
  .header-view-nav{
    .van-icon{
      color: #373737;
    }
  }

</style>
